import {IPaymentArticlesRepository} from "@/repository/finance/payment_articles/PaymentArticlesRepository.types";
import {IPaymentArticles, IPaymentArticlesListItem, PaymentArticlesResponseType} from "@/entity/finance/payment_articles/paymentArticles.types";
import Api from "@/repository/api";
import PaymentArticles from "@/entity/finance/payment_articles/paymentArticles";
import {PaymentArticlesGeneralRequestType} from "@/form/finance/payment_articles/PaymentArticlesGeneral.types";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";

export class PaymentArticlesRepository implements IPaymentArticlesRepository {
    async fetchAll(data?: FormData): Promise<IPaymentArticles> {
        const response = await Api.get(`/finance/payment_articles/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as PaymentArticlesResponseType;
        return new PaymentArticles(responseData);
    }
    async fetchIncome(data?: FormData): Promise<IPaymentArticles>{
        const response = await Api.get(`/finance/payment_articles/getIncome`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as PaymentArticlesResponseType;
        return new PaymentArticles(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IPaymentArticlesListItem> {
        const response = await Api.get(`/finance/payment_articles/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as PaymentArticlesResponseType;
        return new PaymentArticles(responseData).data[0];
    }
    async create(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/payment_articles/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/payment_articles/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/payment_articles/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}
